import { apiGet } from 'api';
import { GetCaseDetailsResponse } from 'types';

export const getCaseDetails = (consultationId: number): Promise<GetCaseDetailsResponse> =>
  apiGet<GetCaseDetailsResponse>(`consultations/${consultationId}/casedetail`);
